export default{
  "Video Compressor": "Compresseur vidéo",
  "HitPaw Online Video Compressor": "HitPaw compresseur vidéo en ligne",
  "Best video compressor tool to reduce video file size online without losing quality.": "Meilleur outil de compression vidéo pour réduire la taille du fichier vidéo en ligne sans perte de qualité.",
  "Quality": "Qualité",
  "Small Size": "Petite taille ({{num}} %)",
  "High Quality": "Haute qualité ({{num}} %)",
  "Frame Rate": "Fréquence d'images",
  "Resolution": "Résolution",
  "Keep Resolution": "Conserver la résolution",
  "Format": "Format",
  "Compress": "Compresse",
  "Compressing": "Compression en cours",
  "Compress New": "Compresser nouveau",
  "xx% reduction in size!": "{{num}} % de réduction de taille !",
  "Compressed successfully, your file is now xxMB.": "Compressé avec succès, votre fichier fait maintenant <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p> Mo.",
  "Compression Failed": "Échec de la compression",
};